var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.position)?_c('div',{staticClass:"tab-pill",class:[("direction-" + _vm.direction)],style:({
		left: ((_vm.position.left) + "px"),
		right: ((_vm.position.right) + "px"),
		top: ((_vm.position.top) + "px"),
		height: ((_vm.position.height) + "px"),
	})}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }